<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-select size="small" v-model="agentId" clearable filterable placeholder="选择代理" style="width: 180px;" class="handle-select mr10" @change="onAgentChange">
          <el-option v-for="item in agentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select size="small" v-model="companyId" clearable filterable placeholder="选择企业" style="width: 200px;" class="handle-select mr10">
          <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-input size="small" v-model="phone" clearable maxlength="12" placeholder="号码" style="width: 130px;"
                  class="handle-input mr10"></el-input>
        <el-input size="small" v-model="fileBatchNo" clearable placeholder="批次号" style="width: 120px;"
                  class="handle-input mr10"></el-input>
        <el-select size="small" v-model="status" clearable placeholder="状态" style="width: 100px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option :value="0" label="待处理"></el-option>
          <el-option :value="1" label="已处理"></el-option>
        </el-select>
        <el-select size="small" v-model="refundStatus" clearable placeholder="退款状态" style="width: 100px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option :value="false" label="未退款"></el-option>
          <el-option :value="true" label="已退款"></el-option>
        </el-select>

        <el-select size="small" v-model="packagesName" clearable filterable placeholder="选择套餐" style="width: 160px;" class="handle-select mr10">
          <el-option :value="null" label="全部套餐"></el-option>
          <el-option v-for="item in packagesOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">搜索</el-button>
        <el-button size="small" type="info" :class="[theme]" icon="el-icon-view" @click="toggleCustomerView">
          {{ isCustomerView ? '内部视图' : '客户视图' }}
        </el-button>
        <!--			<el-button size="small" type="primary" :class="[theme]" icon="el-icon-plus" @click="handleAdd" v-if="isAdmin && !isCustomerView">充值套餐</el-button>-->
        <el-button size="small" type="success" :class="[theme]" icon="el-icon-upload2" @click="handleBatchTopUp"
                   v-if="isAdmin && !isCustomerView">批量充值
        </el-button>
        <el-button size="small" type="warning" :class="[theme]" icon="el-icon-document" @click="handleFileRecharge"
                   v-if="isAdmin && !isCustomerView">文件充值
        </el-button>
        <!--			<el-button size="small" type="success" :class="[theme]" icon="el-icon-check" @click="handleProcess" v-if="isAdmin && !isCustomerView">批量处理</el-button>-->
        <!--			<el-button size="small" type="warning" :class="[theme]" icon="el-icon-view" @click="handleProcessNextMonthTest" v-if="isAdmin && !isCustomerView">测试-次月到账</el-button>-->
        			<el-button size="small" type="danger" :class="[theme]" icon="el-icon-bell" @click="handleProcessNextMonthFormal" v-if="isAdmin && !isCustomerView">次月到账</el-button>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
      <!--			<el-table :key="tableKey" :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"-->
      <!--			max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px', 'pointer-events': 'none' }"-->
      <!--			:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading" @selection-change="handleSelectionChange"-->
      <!--			style="cursor: default;">-->
      <el-table
          :key="tableKey"
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          max-height="600"
          :row-style="{ height: '20px' }"
          :cell-style="{ padding: '6px' }"
          :header-cell-style="{ 'text-align': 'center' }"
          stripe
          v-loading="loading"
          @selection-change="handleSelectionChange"
          style="cursor: default;">
        <el-table-column type="selection" width="55" v-if="!isCustomerView"></el-table-column>
        <el-table-column prop="phone" label="号码" width="120" align="center">
          <template #default="scope">
						<span @click="copyPhone(scope.row.phone)" style="pointer-events: auto; cursor: pointer; color: #409eff;">
							{{ scope.row.phone }}
						</span>
          </template>
        </el-table-column>
        <el-table-column prop="packagesName" label="套餐名称" align="center" show-overflow-tooltip
                         :width="isCustomerView ? undefined : '120'">
          <template #default="scope">
            {{ isCustomerView ? (scope.row.sjtxPackagesName || scope.row.packagesName) : scope.row.packagesName }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="套餐类型" align="center" width="120" v-if="!isCustomerView">
          <template #default="scope">
            <span v-if="scope.row.type == 0">整月套餐</span>
            <span v-if="scope.row.type == 1">首月上下半月</span>
          </template>
        </el-table-column>
        <el-table-column prop="rechargeAmount" label="充值金额" align="center" width="70">
          <template #default="scope">
            <span>{{ scope.row.rechargeAmount }}元</span>
          </template>
        </el-table-column>
        <el-table-column label="已到账金额" align="center" width="90">
          <template #default="scope">
            <!-- 客户视图 -->
            <template v-if="isCustomerView">
							<span :style="{ color: '#67c23c', fontWeight: 'bold' }">
								<!-- 多充值次月已处理：立即到账 + 次月实际到账 + 截留 -->
								<template v-if="scope.row.nextMonthProcessed && scope.row.nextMonthArrivalAmount">
									{{ ((scope.row.arrivalAmount || 0) + (scope.row.nextMonthActualArrivalAmount || scope.row.nextMonthArrivalAmount || 0) + (scope.row.needIntercept || 0)).toFixed(2) }}元
								</template>
								<!-- 正常次月已处理（status=1） -->
								<template v-else-if="scope.row.status == 1">
									{{ (scope.row.arrivalAmount + (scope.row.needIntercept || 0)).toFixed(2) }}元
								</template>
                <!-- 未处理订单：只显示立即到账金额 -->
								<template v-else>
									{{ (scope.row.arrivalAmount || 0).toFixed(2) }}元
								</template>
							</span>
            </template>
            <!-- 内部视图：显示真实到账金额 -->
            <template v-else>
							<span :style="{ color: '#67c23c', fontWeight: 'bold' }">
								<!-- 多充值次月已处理：立即到账 + 次月实际到账 -->
								<template v-if="scope.row.nextMonthProcessed && scope.row.nextMonthArrivalAmount">
									{{ ((scope.row.arrivalAmount || 0) + (scope.row.nextMonthActualArrivalAmount || scope.row.nextMonthArrivalAmount || 0)).toFixed(2) }}元
								</template>
								<template v-else>
									{{ scope.row.arrivalAmount }}元
								</template>
							</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="待到账金额" align="center" width="110" v-if="hasNextMonthOverchargeRecord">
          <template #default="scope">
						<span :style="{ color: '#e6a23c', fontWeight: 'bold' }">
							<template v-if="isCustomerView">
								<!-- 客户视图:未处理订单显示待到账+截留,已处理订单不显示 -->
								<template v-if="scope.row.status == 0">
									<template v-if="scope.row.nextMonthArrivalAmount && !scope.row.nextMonthProcessed">
										{{ (scope.row.nextMonthArrivalAmount + (scope.row.needIntercept || 0)).toFixed(2) }}元
									</template>
									<template
                      v-else-if="scope.row.normalNextMonthArrival !== undefined && scope.row.normalNextMonthArrival !== null">
										{{ (scope.row.normalNextMonthArrival + (scope.row.needIntercept || 0)).toFixed(2) }}元
									</template>
									<template v-else>
										-
									</template>
								</template>
								<template v-else>
									-
								</template>
							</template>
							<template v-else>
								<!-- 内部视图:显示真实数据 -->
								<template v-if="scope.row.status == 0">
									<template v-if="scope.row.nextMonthArrivalAmount && !scope.row.nextMonthProcessed">
										{{ scope.row.nextMonthArrivalAmount }}元
									</template>
									<template
                      v-else-if="scope.row.normalNextMonthArrival !== undefined && scope.row.normalNextMonthArrival !== null">
										{{ scope.row.normalNextMonthArrival.toFixed(2) }}元
									</template>
									<template v-else>
										-
									</template>
								</template>
								<template v-else>
									-
								</template>
							</template>
						</span>
          </template>
        </el-table-column>
        <el-table-column prop="year_month" label="套餐周期" align="center" width="90"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="100">
          <template #default="scope">
            <el-tag v-if="scope.row.status == 0" type="warning">待处理</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">已处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="fileBatchNo" label="批次号" align="center" width="150" v-if="!isCustomerView">
          <template #default="scope">
					<span @dblclick="copyBatchNo(scope.row.fileBatchNo)" style="pointer-events: auto; cursor: pointer;"
                :title="scope.row.fileBatchNo || ''">
						{{ scope.row.fileBatchNo || '-' }}
					</span>
          </template>
        </el-table-column>
        <el-table-column prop="userPhone" label="操作人" align="center" width="120"
                         v-if="!isCustomerView"></el-table-column>
        <el-table-column prop="createdAt" label="充值时间" align="center" width="160">
          <template #default="scope">
            <span>{{ formatDateTime(scope.row.createdAt) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="processTime" label="到账时间" align="center" width="160" v-if="!isCustomerView">
          <template #default="scope">
            <span>{{ formatDateTime(scope.row.processTime) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="150" v-if="isAdmin && !isCustomerView">
          <template #default="scope">
					<span
              :class="(!scope.row.refund && scope.row.orderId) ? 'refund-text' : 'disabled-text'"
              @click="(!scope.row.refund && scope.row.orderId) ? handleRefund(scope.row) : null"
              style="pointer-events: auto !important; cursor: pointer !important; margin-right: 10px;">
						返销
					</span>
            <span
                @click="handleViewRemark(scope.row)"
                style="pointer-events: auto !important; cursor: pointer !important; color: #409eff;">
						备注
					</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                       :current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100]"
                       :page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>

    <el-dialog title="充值套餐" v-model="addVisible" width="520px" @close="closeDialog">
      <el-form label-width="130px" :model="addForm" ref="editForm">
        <el-form-item label="号码" prop="phone">
          <el-input size="small" v-model="addForm.phone" placeholder="请输入号码"></el-input>
        </el-form-item>
        <el-form-item label="套餐名称" prop="packagesName">
          <el-select size="small" v-model="addForm.packagesName" placeholder="请选择套餐" style="width: 100%;"
                     @change="handlePackageChange">
            <el-option v-for="item in packagesList" :key="item.id" :label="item.packagesName"
                       :value="item.packagesName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="套餐类型" prop="type" v-if="currentPackage">
          <span>{{ currentPackage.type == 0 ? '整月套餐' : '首月上下半月套餐，次月整月' }}</span>
        </el-form-item>
        <el-form-item label="当前周期" prop="period" v-if="currentPackage">
          <span>{{ period == 0 ? '上半月' : '下半月' }}</span>
        </el-form-item>
        <el-form-item label="用户充值金额" prop="rechargeAmount" v-if="currentPackage">
          <span>{{ rechargeAmount }}元</span>
        </el-form-item>
        <el-form-item label="到账金额" prop="arrivalAmount" v-if="currentPackage">
          <span>{{ arrivalAmount }}元</span>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button size="small" type="primary" :class="[theme]" @click="submitAdd">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="批量充值套餐" v-model="batchVisible" width="1000px" @close="closeBatchDialog">
      <div class="batch-dialog-content">
        <!-- 输入区域 -->
        <div class="batch-input-section">
          <el-input
              type="textarea"
              v-model="batchPhones"
              placeholder="请输入号码，每行一个"
              :rows="5"
              class="batch-textarea">
          </el-input>
          <el-button
              type="primary"
              :class="[theme]"
              @click="batchQuery"
              :loading="batchQueryLoading"
              style="margin-top: 10px;">
            查询
          </el-button>
        </div>

        <!-- 查询结果表格 -->
        <el-table
            :data="batchResult"
            border
            class="batch-table"
            max-height="400"
            v-loading="batchQueryLoading">
          <el-table-column prop="phone" label="号码" width="130" align="center"></el-table-column>
          <el-table-column prop="state" label="号码状态" width="120" align="center">
            <template #default="scope">
							<span :style="{color: scope.row.state && scope.row.state.includes('待激活') ? '#ff6600' : '#3dbf15'}">
								{{ scope.row.state || '查询失败' }}
							</span>
            </template>
          </el-table-column>
          <el-table-column prop="ORDER_NAME" label="套餐名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="packageAmount" label="套餐金额" width="100" align="center">
            <template #default="scope">
              <span v-if="scope.row.packageAmount">{{ scope.row.packageAmount }}元</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="actualRechargeAmount" label="实际充值金额" width="120" align="center">
            <template #default="scope">
							<span v-if="scope.row.actualRechargeAmount" style="color: #ff0000; font-weight: bold;">
								{{ scope.row.actualRechargeAmount }}元
							</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="是否可充值" width="100" align="center">
            <template #default="scope">
							<span :style="{color: scope.row.canRecharge ? '#3dbf15' : '#ff0000', fontWeight: 'bold'}">
								{{ scope.row.canRecharge ? '可充值' : '不可充值' }}
							</span>
            </template>
          </el-table-column>
          <el-table-column prop="rechargeTip" label="提示" align="center" show-overflow-tooltip></el-table-column>
        </el-table>

        <!-- 汇总信息 -->
        <div class="batch-summary" v-if="batchResult.length > 0">
          <span class="summary-item">可充值数量：<strong style="color: #3dbf15;">{{ rechargeCount }}</strong> 个</span>
          <span class="summary-item">总充值金额：<strong style="color: #ff0000; font-size: 18px;">{{
              totalAmount
            }}</strong> 元</span>
        </div>

        <!-- 操作按钮 -->
        <div class="batch-actions">
          <el-button size="small" @click="batchVisible = false">取消</el-button>
          <el-button
              size="small"
              type="primary"
              :class="[theme]"
              @click="confirmBatchTopUp"
              :loading="batchSubmitLoading"
              :disabled="rechargeCount === 0">
            确认充值（{{ rechargeCount }}个号码，共{{ totalAmount }}元）
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 文件充值对话框 -->
    <el-dialog title="文件充值" v-model="fileVisible" width="90%" @close="closeFileDialog"
               :close-on-click-modal="false">
      <div class="file-recharge-dialog">
        <div v-if="!fileResult" class="file-upload-area">
          <div class="file-tip">
            <el-icon class="el-icon-warning" style="color: #e6a23c; font-size: 24px; margin-right: 8px;"></el-icon>
            <span>请上传Excel文件，第一列为号码，第二列为充值金额</span>
          </div>
          <el-upload
              class="upload-demo"
              drag
              action=""
              :auto-upload="false"
              :on-change="handleFileChange"
              :limit="1"
              accept=".xlsx,.xls">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <template #tip>
              <div class="el-upload__tip">
                只能上传xlsx/xls文件，<a href="javascript:;" @click="downloadTemplate">点击下载模板</a>
              </div>
            </template>
          </el-upload>
        </div>

        <!-- 预览表格 -->
        <div v-if="fileResult && fileResult.previewData" class="file-preview-area">
          <el-table :data="fileResult.previewData" border style="width: 100%;" max-height="400">
            <el-table-column prop="phone" label="号码" width="130" align="center"></el-table-column>
            <el-table-column prop="state" label="号码状态" width="120" align="center">
              <template #default="scope">
								<span :style="{ color: scope.row.state && scope.row.state.includes('待激活') ? '#e6a23c' : '#67c23a' }">
									{{ scope.row.state || '-' }}
								</span>
              </template>
            </el-table-column>
            <el-table-column prop="packagesName" label="套餐名称" align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageAmount" label="套餐金额" width="100" align="center">
              <template #default="scope">
                {{ scope.row.packageAmount ? scope.row.packageAmount + '元' : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="dxtPrice" label="迪信通价格" width="120" align="center">
              <template #default="scope">
                {{ scope.row.dxtPrice ? scope.row.dxtPrice + '元' : '-' }}
              </template>
            </el-table-column>
            <el-table-column prop="balance" label="账户余额" width="100" align="center">
              <template #default="scope">
                {{ scope.row.balance ? scope.row.balance.toFixed(2) + '元' : '0元' }}
              </template>
            </el-table-column>
            <el-table-column prop="needAmount" label="需要充值" width="100" align="center">
              <template #default="scope">
								<span :style="{ color: scope.row.needAmount > 0 ? '#ff0000' : '#67c23a', fontWeight: 'bold' }">
									{{ scope.row.needAmount ? scope.row.needAmount.toFixed(2) + '元' : '0元' }}
								</span>
              </template>
            </el-table-column>
            <el-table-column prop="userAmount" label="用户充值金额" width="120" align="center">
              <template #default="scope">
								<span
                    :style="{ color: scope.row.userAmount > 0 ? '#409eff' : '#909399', fontWeight: scope.row.userAmount > 0 ? 'bold' : 'normal' }">
									{{ scope.row.userAmount ? scope.row.userAmount + '元' : '-' }}
								</span>
              </template>
            </el-table-column>
            <el-table-column prop="arrivalAmount" label="立即到账" width="100" align="center"
                             v-if="hasNextMonthOvercharge">
              <template #default="scope">
								<span v-if="scope.row.isNextMonthOvercharge" :style="{ color: '#67c23a', fontWeight: 'bold' }">
									{{
                    scope.row.immediateArrivalAmount !== undefined && scope.row.immediateArrivalAmount !== null ? scope.row.immediateArrivalAmount.toFixed(2) + '元' : '-'
                  }}
								</span>
                <span v-else>0.00元</span>
              </template>
            </el-table-column>
            <el-table-column label="次月到账" width="100" align="center" v-if="hasNextMonthOvercharge">
              <template #default="scope">
								<span v-if="scope.row.isNextMonthOvercharge" :style="{ color: '#e6a23c', fontWeight: 'bold' }">
									{{
                    scope.row.nextMonthArrivalAmount !== undefined && scope.row.nextMonthArrivalAmount !== null ? scope.row.nextMonthArrivalAmount.toFixed(2) + '元' : '-'
                  }}
								</span>
                <span
                    v-else-if="scope.row.normalNextMonthArrival !== undefined && scope.row.normalNextMonthArrival !== null"
                    :style="{ color: '#e6a23c', fontWeight: 'bold' }">
									{{ scope.row.normalNextMonthArrival.toFixed(2) + '元' }}
								</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="yearMonth" label="套餐周期" width="100" align="center">
              <template #default="scope">
                {{ scope.row.yearMonth || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="是否可充值" width="100" align="center">
              <template #default="scope">
								<span :style="{ color: scope.row.canRecharge ? '#67c23a' : '#f56c6c', fontWeight: 'bold' }">
									{{ scope.row.canRecharge ? '可充值' : '不可充值' }}
								</span>
              </template>
            </el-table-column>
            <el-table-column prop="tip" label="提示" align="center" show-overflow-tooltip></el-table-column>
          </el-table>

          <!-- 汇总信息 -->
          <div class="file-summary" v-if="fileResult.canRechargeCount > 0">
            <span class="summary-item">可充值数量：<strong style="color: #3dbf15;">{{
                fileResult.canRechargeCount
              }}</strong> 个</span>
            <span class="summary-item">总充值金额：<strong
                style="color: #ff0000; font-size: 18px;">{{ fileResult.totalAmount.toFixed(2) }}</strong> 元</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="file-actions">
          <el-button size="small" @click="closeFileDialog">取消</el-button>
          <el-button
              v-if="!fileResult"
              size="small"
              type="primary"
              :class="[theme]"
              @click="previewFileRecharge"
              :loading="fileSubmitLoading"
              :disabled="!fileData">
            解析文件
          </el-button>
          <el-button
              v-if="fileResult && fileResult.canRechargeCount > 0"
              size="small"
              type="primary"
              :class="[theme]"
              @click="confirmFileRecharge"
              :loading="fileConfirmLoading">
            确认充值（{{ fileResult.canRechargeCount }}个号码，共{{ fileResult.totalAmount.toFixed(2) }}元）
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 备注弹窗 -->
    <el-dialog title="订单详情" v-model="remarkVisible" width="600px">
      <div style="padding: 10px; line-height: 2;">
        <div><strong>创建时间：</strong>{{ currentCreatedAt }}</div>
        <div v-if="currentRemark" style="margin-top: 15px; border-top: 1px solid #e4e7ed; padding-top: 15px;">
          <strong>备注内容：</strong>
          <div style="margin-top: 8px; background: #f5f7fa; padding: 12px; border-radius: 4px; white-space: pre-wrap;">
            {{ currentRemark }}
          </div>
        </div>
        <div v-else style="margin-top: 15px; color: #909399;">无备注</div>
      </div>
      <template #footer>
        <el-button size="small" @click="remarkVisible = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
	getDxtPackagesOfNumber,
	packageTopUp,
	getPackageTopUpRecord,
	processPackageTopUp,
	refundPackageTopUp,
	batchPhoneInfo,
	batchTopUp,
	fileRechargePreview,
	fileRechargeConfirm,
	downloadTemplate,
	processNextMonthArrivalTest,
	processNextMonthArrivalFormal,
	previewNextMonthArrival,
	getCompaniesWithRecords,
	exportPackageTopUpRecord
} from '../api/dijia.js';
import { fetchAgent } from '../api/agentIndex.js';
import { fetchCompanyByAgentId } from '../api/companyIndex.js';

export default {
  name: 'DxtPackageTopUp',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      theme3: localStorage.getItem('theme3'),
      theme8: localStorage.getItem('theme8'),
      phone: '',
      fileBatchNo: '',
      status: null,
      refundStatus: null,
      agentId: null,
      companyId: null,
      packagesName: null,
      agentOptions: [],
      companyOptions: [],
      packagesOptions: [],
      query: {
        pageIndex: 1,
        pageSize: 10,
        userId: localStorage.getItem('user')
      },
      tableData: [],
      pageTotal: 0,
      multipleSelection: [],
      packagesList: [],
      addForm: {
        phone: '',
        packagesName: ''
      },
      addVisible: false,
      currentPackage: null,
      period: 0,
      rechargeAmount: 0,
      arrivalAmount: 0,
      selectedIds: [],
      isAdmin: false,
      isCompany: false,
      isAgent: false,
      // 批量充值相关
      batchVisible: false,
      batchPhones: '',
      batchResult: [],
      batchQueryLoading: false,
      batchSubmitLoading: false,
      // 文件充值相关
      fileVisible: false,
      fileData: null,
      fileResult: null,
      fileSubmitLoading: false,
      fileConfirmLoading: false,
      // 备注弹窗
      remarkVisible: false,
      currentRemark: '',
      currentCreatedAt: '',
      // 客户视图
      isCustomerView: false,
      // 表格key，用于切换视图时强制重新渲染
      tableKey: 0
    };
  },

  created() {
    let role = localStorage.getItem('ms_role');
    if (role === 'company') {
      this.isCompany = true;
    }
    if (role === 'admin') {
      this.isAdmin = true;
    }
    if (role === 'agent') {
      this.isAgent = true;
    }
    this.getData();
    this.getPackagesList();
    this.calculatePeriod();
    this.loadAgents();
    this.loadPackageNames();
  },

  computed: {
    // 可充值数量
    rechargeCount() {
      return this.batchResult.filter(r => r.canRecharge).length;
    },
    // 总充值金额
    totalAmount() {
      return this.batchResult
          .filter(r => r.canRecharge && r.actualRechargeAmount)
          .reduce((sum, r) => sum + parseFloat(r.actualRechargeAmount || 0), 0)
          .toFixed(2);
    },
    // 文件充值预览是否有次月套餐多充值
    hasNextMonthOvercharge() {
      if (!this.fileResult || !this.fileResult.previewData) {
        return false;
      }
      return this.fileResult.previewData.some(r => r.isNextMonthOvercharge);
    },
    // 充值记录列表是否有次月套餐多充值或普通次月套餐
    hasNextMonthOverchargeRecord() {
      return this.tableData.some(r =>
          r.immediateArrivalAmount !== undefined && r.immediateArrivalAmount !== null ||
          r.nextMonthArrivalAmount !== undefined && r.nextMonthArrivalAmount !== null ||
          r.normalNextMonthArrival !== undefined && r.normalNextMonthArrival !== null
      );
    }
  },

  methods: {
    loadAgents() {
      fetchAgent(localStorage.getItem('user')).then(res => {
        if (res?.code === 200) {
          this.agentOptions = res.data || [];
        }
      });
    },
    onAgentChange() {
      this.companyId = null;
      this.companyOptions = [];
      if (this.agentId) {
        // 调用新接口，只查询有账务记录的企业
        getCompaniesWithRecords(this.agentId).then(res => {
          if (res?.code === 200) {
            this.companyOptions = res.data || [];
          }
        }).catch(err => {
          console.error(err);
          // 出错时回退到旧接口
          fetchCompanyByAgentId({ agentId: this.agentId, subAgent: false }).then(res => {
            if (res?.code === 200) {
              this.companyOptions = res.data || [];
            }
          });
        });
      }
    },
    loadPackageNames() {
      getDxtPackagesOfNumber().then(res => {
        if (res?.code === 200) {
          this.packagesOptions = (res.data || []).map(item => item.packagesName).filter(Boolean);
        }
      });
    },
    // 复制号码
    copyPhone(phone) {
      navigator.clipboard.writeText(phone).then(() => {
        this.$message.success('号码已复制：' + phone);
      }).catch(err => {
        // 降级方案
        const textarea = document.createElement('textarea');
        textarea.value = phone;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$message.success('号码已复制：' + phone);
        } catch (e) {
          this.$message.error('复制失败，请手动复制');
        }
        document.body.removeChild(textarea);
      });
    },
    // 复制批次号
    copyBatchNo(batchNo) {
      if (!batchNo) {
        this.$message.warning('批次号为空');
        return;
      }
      navigator.clipboard.writeText(batchNo).then(() => {
        this.$message.success('批次号已复制');
      }).catch(err => {
        // 降级方案
        const textarea = document.createElement('textarea');
        textarea.value = batchNo;
        textarea.style.position = 'fixed';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$message.success('批次号已复制');
        } catch (e) {
          this.$message.error('复制失败，请手动复制');
        }
        document.body.removeChild(textarea);
      });
    },
    // 切换客户视图
    toggleCustomerView() {
      this.isCustomerView = !this.isCustomerView;
      // 更新表格key，强制重新渲染表格
      this.tableKey++;
      if (this.isCustomerView) {
        this.$message.info('已切换到客户视图，只显示基本信息');
      } else {
        this.$message.info('已切换到内部视图');
      }
    },
    calculatePeriod() {
      const today = new Date();
      const day = today.getDate();
      this.period = day <= 15 ? 0 : 1;
    },
    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getPackagesList() {
      getDxtPackagesOfNumber().then(res => {
        if (res?.code === 200) {
          this.packagesList = res.data;
          // 当 packagesList 加载完成后，如果 tableData 已经有数据，处理一下
          if (this.tableData && this.tableData.length > 0) {
            this.processTableData();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getData() {
      this.loading = true;
      let params = {
        phone: this.phone,
        fileBatchNo: this.fileBatchNo,
        status: this.status,
        refundStatus: this.refundStatus,
        agentId: this.agentId,
        companyId: this.companyId,
        packagesName: this.packagesName,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize
      };
      getPackageTopUpRecord(params).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData = res.data.list;
          this.pageTotal = res.data.total;
          // 只有当 packagesList 已经加载好时才处理
          if (this.packagesList && this.packagesList.length > 0) {
            this.processTableData();
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    processTableData() {
      // 给每条记录添加 sjtxPackagesName
      this.tableData.forEach(record => {
        const foundPackage = this.packagesList.find(p => p.packagesName === record.packagesName);
        if (foundPackage) {
          record.sjtxPackagesName = foundPackage.sjtxPackagesName;
        }
      });
    },
    handleAdd() {
      this.addVisible = true;
      this.addForm = {
        phone: '',
        packagesName: ''
      };
      this.currentPackage = null;
      this.rechargeAmount = 0;
      this.arrivalAmount = 0;
    },
    handlePackageChange(packagesName) {
      this.currentPackage = this.packagesList.find(item => item.packagesName === packagesName);
      if (this.currentPackage) {
        if (this.currentPackage.type === 0) {
          this.rechargeAmount = this.currentPackage.sjtxPrice;
          this.arrivalAmount = this.currentPackage.dxtPrice;
        } else {
          if (this.period === 0) {
            this.rechargeAmount = this.currentPackage.sjtxPrice;
            this.arrivalAmount = this.currentPackage.dxtPrice;
          } else {
            this.rechargeAmount = this.currentPackage.sjtxPrice / 2;
            this.arrivalAmount = this.currentPackage.dxtPrice / 2;
          }
        }
      }
    },
    submitAdd() {
      if (!this.addForm.phone) {
        this.$message.error('号码不能为空');
        return;
      }
      if (!this.addForm.packagesName) {
        this.$message.error('套餐名称不能为空');
        return;
      }
      let data = {
        phone: this.addForm.phone,
        packagesName: this.addForm.packagesName,
        userPhone: localStorage.getItem('ms_username')
      };
      packageTopUp(data).then(res => {
        if (res?.code === 200) {
          this.$message.success('充值申请提交成功');
          this.getData();
        } else {
          this.$message.error(res.message);
        }
        this.addVisible = false;
      });
    },
    closeDialog() {
      this.addVisible = false;
    },
    handleSelectionChange(selection) {
      this.selectedIds = selection.map(item => item.id);
    },
    handleProcess() {
      if (this.selectedIds.length === 0) {
        this.$message.error('请选择要处理的记录');
        return;
      }
      this.$confirm('确定要批量处理选中的记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        processPackageTopUp(this.selectedIds.join(',')).then(res => {
          if (res?.code === 200) {
            this.$message.success('处理成功');
            this.getData();
            this.selectedIds = [];
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {
      });
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getData();
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    // 批量充值相关方法
    handleBatchTopUp() {
      this.batchVisible = true;
      this.batchPhones = '';
      this.batchResult = [];
    },
    closeBatchDialog() {
      this.batchVisible = false;
      this.batchPhones = '';
      this.batchResult = [];
    },
    batchQuery() {
      // 解析输入的号码（按换行分隔）
      const phones = this.batchPhones
          .split('\n')
          .map(p => p.trim())
          .filter(p => p);

      if (phones.length === 0) {
        this.$message.error('请输入至少一个号码');
        return;
      }

      this.batchQueryLoading = true;
      this.batchResult = [];

      batchPhoneInfo(phones).then(res => {
        this.batchQueryLoading = false;
        if (res?.code === 200) {
          this.batchResult = res.data;
          this.$message.success('查询完成');
        } else {
          this.$message.error(res.message || '查询失败');
        }
      }).catch(err => {
        this.batchQueryLoading = false;
        this.$message.error('查询失败，请稍后再试');
        console.error(err);
      });
    },
    confirmBatchTopUp() {
      if (this.rechargeCount === 0) {
        this.$message.error('没有可充值的号码');
        return;
      }

      this.$confirm(`确定要充值 ${this.rechargeCount} 个号码，总金额 ${this.totalAmount} 元吗？`, '提示', {
        confirmButtonText: '确定充值',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchSubmitLoading = true;

        // 只充值 canRecharge=true 的号码
        const rechargeList = this.batchResult.filter(r => r.canRecharge);

        batchTopUp({
          phones: rechargeList,
          userId: localStorage.getItem('user')
        }).then(res => {
          this.batchSubmitLoading = false;
          if (res?.code === 200) {
            this.$message.success(res.message || '批量充值成功');
            this.closeBatchDialog();
            this.getData(); // 刷新列表
          } else {
            this.$message.error(res.message || '批量充值失败');
          }
        }).catch(err => {
          this.batchSubmitLoading = false;
          this.$message.error('批量充值失败，请稍后再试');
          console.error(err);
        });
      }).catch(() => {
      });
    },
    handleRefund(row) {
      this.$confirm(`确定要返销号码 ${row.phone} 的充值记录吗？返销后该号码可以更换套餐。`, '提示', {
        confirmButtonText: '确定返销',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.info('正在处理返销，请稍候...');
        refundPackageTopUp({recordId: row.id}).then(res => {
          if (res?.code === 200) {
            this.$message.success('返销成功');
            this.getData();
          } else {
            this.$message.error(res.message || '返销失败');
          }
        }).catch(err => {
          this.$message.error('返销失败，请稍后再试');
          console.error(err);
        });
      }).catch(() => {
      });
    },
    // 文件充值相关方法
    handleFileRecharge() {
      this.fileVisible = true;
      this.fileData = null;
      this.fileResult = null;
      this.fileSubmitLoading = false;
      this.fileConfirmLoading = false;
    },
    handleFileChange(file) {
      this.fileData = file.raw;
      this.fileResult = null;
    },
    downloadTemplate() {
      downloadTemplate().then(res => {
        const url = window.URL.createObjectURL(new Blob([res]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '文件充值模板.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(err => {
        this.$message.error('下载模板失败');
        console.error(err);
      });
    },
    previewFileRecharge() {
      if (!this.fileData) {
        this.$message.error('请选择文件');
        return;
      }

      this.fileSubmitLoading = true;
      const formData = new FormData();
      formData.append('file', this.fileData);

      fileRechargePreview(formData).then(res => {
        this.fileSubmitLoading = false;
        if (res?.code === 200) {
          this.fileResult = res.data;
          if (this.fileResult.canRechargeCount === 0) {
            this.$message.warning('没有可充值的号码');
          }
        } else {
          this.$message.error(res.message || '解析失败');
        }
      }).catch(err => {
        this.fileSubmitLoading = false;
        this.$message.error('解析失败，请稍后再试');
        console.error(err);
      });
    },
    confirmFileRecharge() {
      if (!this.fileResult || this.fileResult.canRechargeCount === 0) {
        this.$message.error('没有可充值的号码');
        return;
      }

      this.$confirm(`确定要充值 ${this.fileResult.canRechargeCount} 个号码，总金额 ${this.fileResult.totalAmount.toFixed(2)} 元吗？`, '提示', {
        confirmButtonText: '确定充值',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fileConfirmLoading = true;

        // 传递userId和previewData
        const requestData = {
          userId: localStorage.getItem('user'),
          previewData: this.fileResult.previewData
        };

        fileRechargeConfirm(requestData).then(res => {
          this.fileConfirmLoading = false;
          if (res?.code === 200) {
            this.$message.success(res.message);
            this.fileVisible = false;
            this.fileData = null;
            this.fileResult = null;
            this.getData();
          } else {
            this.$message.error(res.message || '充值失败');
          }
        }).catch(err => {
          this.fileConfirmLoading = false;
          this.$message.error('充值失败，请稍后再试');
          console.error(err);
        });
      }).catch(() => {
      });
    },
    closeFileDialog() {
      this.fileVisible = false;
      this.fileData = null;
      this.fileResult = null;
      this.fileSubmitLoading = false;
      this.fileConfirmLoading = false;
    },
    handleViewRemark(row) {
      this.currentRemark = row.remark || '';
      this.currentCreatedAt = row.createdAt ? this.formatDateTime(row.createdAt) : '-';
      this.remarkVisible = true;
    },
    // 测试模式：仅输出日志
    handleProcessNextMonthTest() {
      if (this.selectedIds.length === 0) {
        this.$message.warning('请先选择要处理的记录');
        return;
      }

      const selectedRecords = this.tableData.filter(row => this.selectedIds.includes(row.id || row._id));
      const needProcessRecords = selectedRecords.filter(row => {
        if (row.nextMonthArrivalAmount && !row.nextMonthProcessed) return true;
        if (row.normalNextMonthArrival && row.status === 0) return true;
        return false;
      });

      if (needProcessRecords.length === 0) {
        this.$message.warning('所选记录中没有需要处理次月到账的订单');
        return;
      }

      const recordIds = needProcessRecords.map(r => r.id || r._id).join(',');
      const totalAmount = needProcessRecords.reduce((sum, row) => {
        return sum + (row.nextMonthArrivalAmount || row.normalNextMonthArrival || 0);
      }, 0);

      this.$confirm(`【测试模式】将输出日志，不执行实际操作。\n待处理: ${needProcessRecords.length} 个号码，总金额 ${totalAmount.toFixed(2)} 元`, '提示', {
        confirmButtonText: '执行测试',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;

        processNextMonthArrivalTest({recordIds}).then(res => {
          this.loading = false;
          if (res?.code === 200) {
            this.$message.success(res.message);
            this.$alert(
                `测试模式执行完成！\n\n处理记录: ${res.data.count || 0} 条\n跳过记录: ${res.data.skipCount || 0} 条\n\n请查看后端日志获取详细信息。`,
                '测试结果',
                {confirmButtonText: '确定'}
            );
          } else {
            this.$message.error(res.message || '测试失败');
          }
        }).catch(err => {
          this.loading = false;
          this.$message.error('测试失败，请稍后再试');
          console.error(err);
        });
      }).catch(() => {
      });
    },
    // 正式模式：执行实际充值
    handleProcessNextMonthFormal() {
      this.loading = true;
      previewNextMonthArrival().then(res => {
        this.loading = false;
        if (res?.code === 200) {
          const data = res.customData || res.data;
          const { count, totalAmount, capitalPool } = data;
          
          if (count === 0) {
            this.$message.warning('没有需要处理的次月订单');
            return;
          }
          
          const safeTotalAmount = totalAmount || 0;
          const safeCapitalPool = capitalPool || 0;
          this.$confirm(`【正式模式】将执行实际充值操作，扣除资金池并更新记录！\n\n待处理: ${count} 个号码\n总金额: ${safeTotalAmount.toFixed(2)} 元\n资金池余额: ${safeCapitalPool.toFixed(2)} 元\n\n确定要执行吗？`, '警告', {
            confirmButtonText: '确认执行',
            cancelButtonText: '取消',
            type: 'error'
          }).then(() => {
            this.loading = true;

            processNextMonthArrivalFormal({ userId: localStorage.getItem('user') }).then(res => {
              this.loading = false;
              if (res?.code === 200) {
                this.$message.success(res.message);
                
                // 构建弹窗内容
                let alertContent = `提交完成！\n\n`;
                alertContent += `提交成功: ${res.data.successCount || 0} 条\n`;
                alertContent += `提交失败: ${res.data.failCount || 0} 条\n`;
                alertContent += `总金额: ${(res.data.totalAmount || 0).toFixed(2)} 元\n`;
                
                // if (res.data.successList && res.data.successList.length > 0) {
                //   alertContent += `\n成功列表：\n${res.data.successList.join('\n')}`;
                // }
                //
                // if (res.data.failList && res.data.failList.length > 0) {
                //   alertContent += `\n失败列表：\n${res.data.failList.join('\n')}`;
                // }
                
                this.$alert(
                  alertContent,
                  '处理结果',
                  { confirmButtonText: '确定' }
                );
                this.getData(); // 刷新列表
              } else {
                this.$message.error(res.message || '处理失败');
              }
            }).catch(err => {
              this.loading = false;
              this.$message.error('处理失败，请稍后再试');
              console.error(err);
            });
          }).catch(() => {
          });
        } else {
          this.$message.error(res.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('查询失败，请稍后再试');
        console.error(err);
      });
    },
    handleExport() {
      const params = {
        phone: this.phone || '',
        fileBatchNo: this.fileBatchNo || '',
        status: this.status !== null && this.status !== undefined ? this.status : '',
        refundStatus: this.refundStatus !== null && this.refundStatus !== undefined ? this.refundStatus : '',
        agentId: this.agentId || '',
        companyId: this.companyId || '',
        packagesName: this.packagesName || ''
      };
      exportPackageTopUpRecord(params).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = '充值记录.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      }).catch(err => {
        this.$message.error('导出失败');
        console.error(err);
      });
    }
  }
};
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.file-recharge-dialog {
  padding: 10px 0;
}

.file-upload-area {
  text-align: center;
  padding: 20px;
}

.file-tip {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e6a23c;
  font-size: 14px;
}

.file-preview-area {
  margin-bottom: 20px;
}

.file-summary {
  margin-top: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-item {
  font-size: 14px;
  color: #606266;
}

.file-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}

.refund-text {
  color: #f56c6c;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}

.refund-text:hover {
  color: #f23434;
  text-decoration: underline;
}

.disabled-text {
  color: #c0c4cc;
  cursor: not-allowed;
  font-size: 14px;
}

/* 批量充值对话框样式 */
.batch-dialog-content {
  padding: 10px 0;
}

.batch-input-section {
  margin-bottom: 20px;
}

.batch-textarea {
  width: 100%;
}

.batch-table {
  margin-bottom: 20px;
}

.batch-summary {
  background: #f5f7fa;
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-item {
  font-size: 14px;
  color: #606266;
}

.batch-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
